export const APP_NAME = 'Quantix | Nómina y RRHH con IA para México';
export const APP_DESCRIPTION = 'Software de nómina inteligente para México. Cálculo automático IMSS, ISR, CFDI 4.0. Respaldado por Y Combinator. Portal de empleados, CRM y cumplimiento NOM-035.';
